import { CONFIG as developmentConfig } from '@/config/development';
import { CONFIG as integrationConfig } from '@/config/integration';
import { CONFIG as localConfig } from '@/config/local';
import { CONFIG as productionConfig } from '@/config/production';

const environment = process.env.REACT_APP_CLOVER_SPORT_ENV || 'development';

const getConfig = () => {
  switch (environment) {
    case 'production': {
      return productionConfig;
    }
    case 'integration': {
      return integrationConfig;
    }
    case 'local': {
      return localConfig;
    }
    default: {
      return developmentConfig;
    }
  }
};

const getConfigValue = (key) => {
  const config = getConfig();
  return config[key];
};

export { getConfigValue };
